var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7752 15.998L12.1372 12.412H5.47117L3.24917 15.998H0.0371718L10.2012 0.422047H12.5552L15.6572 15.998H12.7752ZM10.7292 3.54605L6.79117 10.08H11.7632L10.7292 3.54605ZM17.1965 15.998L19.9465 0.422047H22.6525L19.9025 15.998H17.1965Z",
    fill: "#1277A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImg);
export default __webpack_public_path__ + "static/media/AIImg.8c4d4471c86dce345856e778786dbc25.svg";
export { ForwardRef as ReactComponent };